import { useCallback } from 'react'

import { useParameterContext } from '../../context/parameterContext'
import { getParameterDefinitionInOut } from '../../uiModels/parameterOperations/helpers'
import type { IndexedParameterDefinitionCreateOperationWithMetaData } from '../../uiModels/parameterOperations/types'

export const useIsParameterVersionActive = () => {
  const { parameterDefinitionOperation } = useParameterContext()
  const currentParameterDefinitionEntity =
    parameterDefinitionOperation?.internalOperation.entity

  return useCallback(
    (version: IndexedParameterDefinitionCreateOperationWithMetaData) =>
      currentParameterDefinitionEntity?.fromDate ===
        getParameterDefinitionInOut(version).fromDate &&
      currentParameterDefinitionEntity?.name ===
        getParameterDefinitionInOut(version).name,
    [
      currentParameterDefinitionEntity?.fromDate,
      currentParameterDefinitionEntity?.name,
    ],
  )
}
